import React,{useState} from "react";
import ModalContainer from "../../ModalContainer";
import ModalDatePicker from "../../ModalDatePicker";
import ModalInputField from "../../ModalInputField";  
import moment  from "moment";
import { cloneDeep, isEmpty } from "lodash"; 
import { DATE_FORMAT4 } from "../../../constants/stringConstants"; 
import { useAddExperienceMutation, useEditExperienceMutation } from "../../../store/profileSlice";
import HeaderModalText from "../../HeaderModalText";
import { useAppSelector } from "../../../store/store";
import PdfUploadingComponent from "../../PdfUploadingComponent";


function ProfileCompletionExperienceModal({editData,isVisible,onClose}) {
  const { user } = useAppSelector((state) => state["user"]);
    const [input, setInput] = useState({
        jobTitle:editData?.jobTitle??"",
        company:editData?.companyName?.companyName??"",  
        startDate:editData?.from??moment(),   
        endDate:editData?.to??moment(),
      });

      const[loading,setLoading]=useState(false)

      const [error, setError] = useState({ 
        jobTitle:'',
        company:'', 
        startDate:'',
        endDate:'',
      });
      const [addExperience] =
      useAddExperienceMutation();
      const [editExperience] =
      useEditExperienceMutation();

      const[isPresentJob,setIsPresentJob]=useState(editData?.isCurrentlyWorking??false)  
      const [imageFile, setImageFile] = useState(editData?.experienceLetter??'');

const onChangeText = (event) => {
    console.log({event:event}) 
    setInput({
      ...input,
      [event.target.name]: event.target.value,
    });
  };


  const errorSec = (err) => (
    <div style={{ marginBottom: "20px" }}>
      <text style={{ color: "red" }}>{err}</text>
    </div>
  );


  const onChangeStartDate=(date)=>{
    setInput({ ...input, startDate: `${date}` });
  }

  const onChangeEndDate=(date)=>{
    setInput({ ...input, endDate: `${date}` });
  }


  const validation=()=>{

const{ jobTitle,
company, 
startDate, 
endDate}=input

let valid = true;
let jobTitleError = "";
let companyError = "";
let startDateError = "";
let endDateError = "";


if (isEmpty(jobTitle)) {
  valid = false;
  jobTitleError = "Job title cannot be empty";
}

if (isEmpty(company)) {
  valid = false;
  companyError = "Company name cannot be empty";
} 

if (isEmpty(startDate)) {
  valid = false;
  startDateError = "You need to select a start date";
}


if(isEmpty(endDate) && !isPresentJob){
  valid = false;
  endDateError = "You need to select an end date";
}


setError({
  ...error,
  jobTitle:jobTitleError,
  company:companyError,
  startDate:startDateError,
  endDate:endDateError,
});

return valid;
};






const addEditExperience=()=>{
  console.log({imageFile})
if(validation()){
  setLoading(true)

 let experienceData={
   jobTitle:input.jobTitle,
   companyName:{id:"",companyName:input.company},
   from:moment(input.startDate).format(DATE_FORMAT4),
   to:moment(input.endDate).format(DATE_FORMAT4),
   isCurrentlyWorking: isPresentJob,
   experienceLetter:imageFile
  }
 
  console.log({experienceData})
 let payload={}
 
 //add course
 if(isEmpty(editData)){
  payload={
 param:user?.id??'',
 data:[experienceData]
 }
 
 
 addExperience(payload)
       .unwrap()
       .then((incomingData) => {
        setLoading(false)

         console.log({ incomingData });
         onClose()
       })
       .catch((err) => {
        setLoading(false)

         console.log(err);
       });
 
     }
 
     //edit course
 
     else{
       payload={
         param:editData?.id??'',
         data:experienceData
         }
         editExperience(payload)
       .unwrap()
       .then((incomingData) => {
        setLoading(false)

         console.log({ incomingData });
         onClose()
       })
       .catch((err) => {
        setLoading(false)

         console.log(err);
       });
 
     }
   }
   }


  return (
<ModalContainer onClose={onClose} onBtnClick={addEditExperience} isVisible={isVisible}
modalHeaderText={""}
modalSubHeaderText={isEmpty(editData)?"Add Experience":"Edit Experience"}
isLoading={loading}
>
    
<div style={{marginBottom:'2rem'}}>   
<ModalInputField isRequired={true} name={'jobTitle'} headerText={'Job Title'} onChangeText={onChangeText} inputFieldValue={input.jobTitle} hasError={!isEmpty(error.jobTitle)}/>
{!isEmpty(error.jobTitle) && errorSec(error.jobTitle)}

</div>


    <div style={{marginBottom:'2rem'}}>   
<ModalInputField isRequired={true} name={'company'} headerText={'Company'} onChangeText={onChangeText} inputFieldValue={input.company} hasError={!isEmpty(error.company)} />
{!isEmpty(error.company) && errorSec(error.company)}

</div>

<div style={{marginBottom:'2rem'}}>   
<ModalDatePicker headerText={"Start Date"} name={'startDate'} handleChangeDate={onChangeStartDate} dateValue={input.startDate} hasError={!isEmpty(error.startDate)}/>
{!isEmpty(error.startDate) && errorSec(error.startDate)}

</div>   

<div style={{marginBottom:'2rem'}}>  
<div style={{display:'flex',marginBottom:'10px',alignItems:'center'}}> 
<input type="checkbox" onChange={()=>{setIsPresentJob(!isPresentJob)}} style={{width:'25px',height:'25px',marginLeft:'5px',marginRight:'7px'}}  checked={isPresentJob}/>
<text style={{fontSize:'18px',marginTop:'-2px'}}>Currently working here</text>
</div>
<ModalDatePicker headerText={"End Date"} name={'endDate'} handleChangeDate={onChangeEndDate} dateValue={input.endDate} isDateDisabled={isPresentJob} hasError={!isEmpty(error.jobTitle) && !isPresentJob}/>
{!isEmpty(error.endDate) && !isPresentJob && errorSec(error.endDate)}

</div>   

<div style={{flexDirection:'column',flex:1,display:'flex'}} >
  <HeaderModalText text={"Your experience letter"}/>
<PdfUploadingComponent setFile={setImageFile} imageFile={imageFile}/>
</div> 

</ModalContainer>
  );
}

export default ProfileCompletionExperienceModal;
